
import { Vue, Component } from 'vue-property-decorator';
import Api from '@/services/api';
import DatePicker from '@/components/DatePicker.vue';

@Component({ components: { DatePicker } })
export default class Profile extends Vue {
  public countDown = 0;
  public length = 6;
  public formTitle = 'حساب کاربری';
  public confirmEmailDialog = false;
  public confirmEmailFormTitle = 'تائید ایمیل';
  public confirmPhoneNumberDialog = false;
  public confirmPhoneNumberFormTitle = 'تائید شماره تلفن همراه';
  public confirmCode = '';
  public editedItem = {
    isCompanyAccount: false,
    phoneNumber: '',
    phoneNumberConfirmed: true,
    email: '',
    emailConfirmed: false,
    idConfirmed: false,
    firstName: '',
    lastName: ''
  };

  public breadcrumbItems = [
    {
      text: 'صفحه اصلی',
      disabled: false,
      href: '/'
    },
    {
      text: 'حساب کاربری',
      disabled: true,
      href: ''
    }
  ];

  async created() {
    await this.initialize();
  }

  async initialize() {
    this.$showLoading();
    await Api.getUserProfile().then((response: any) => {
      this.editedItem = Object.assign({}, response.data);
      this.$hideLoading();
    });
  }

  async close() {
    this.confirmEmailDialog = false;
    this.confirmPhoneNumberDialog = false;
    this.confirmCode = '';
    this.countDown = 0;
    await this.initialize();
  }

  async updateEmail() {
    const confirmed = await this.$showConfirm('هشدار', 'بعد از تغییر آدرس ایمیل باید با ایمیل جدید وارد شوید. برای ادامه تائید فرمائید.');
    if (confirmed) {
      this.$showLoading();
      await Api.editEmail(this.editedItem.email).then((response: any) => {
        this.$showNotification('success', 'کد فعالسازی برای شما ارسال شد.');
        this.confirmEmailDialog = true;
        this.countDown = 120;
        this.countDownTimer();
        this.$hideLoading();
      });
    }
  }

  async confirmEmail() {
    this.$showLoading();
    await Api.confirmEmail(this.confirmCode).then((response: any) => {
      this.$showNotification('success', 'بروز رسانی ایمیل با موفقیت انجام شد.');
      this.close();
      this.$hideLoading();
    });
  }

  async updatePhoneNumber() {
    const confirmed = await this.$showConfirm('هشدار', 'از تغییر شماره موبایل مطمئن هستید؟');
    if (confirmed) {
      this.$showLoading();
      await Api.editPhoneNumber(this.editedItem.phoneNumber).then((response: any) => {
        this.$showNotification('success', 'کد فعالسازی برای شما ارسال شد.');
        this.countDown = 120;
        this.confirmPhoneNumberDialog = true;
        this.countDownTimer();
        this.$hideLoading();
      });
    }
  }

  async confirmPhoneNumber() {
    this.$showLoading();
    await Api.confirmPhoneNumber(this.confirmCode).then((response: any) => {
      this.$showNotification('success', 'بروز رسانی شماره موبایل انجام شد.');
      this.close();
      this.$hideLoading();
    });
  }

  async updateProfile() {
    const isValid = (this.$refs.Observer as any).validate();
    if (!isValid) {
      return;
    }
    this.$showLoading();
    await Api.editProfile(this.editedItem.firstName, this.editedItem.lastName).then((response: any) => {
      this.$showNotification('success', 'بروز رسانی حساب کاربری انجام شد.');
      this.close();
      this.$hideLoading();
    });
  }

  countDownTimer() {
    if (this.countDown > 0) {
      setTimeout(() => {
        this.countDown -= 1;
        this.countDownTimer();
      }, 1000);
    }
  }
}
